import React from "react";
//#region types
import { SelectInputProps } from "models/propTypes/wintFormPropsTypes";
import { AddressStepProps } from "models/propTypes/customerImportPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { WizardSection, SelectInput, FormFieldLayout, VerticalFormField } from "components/common/wintForms";
//#endregion
import { CsvImportHelper, LocalizationHelperInstance } from "utils/helpers";

const AddressStep: React.FC<AddressStepProps> = ({ connect, submitted, wizardProps, headersObject }) => {
  const billingCityProps = connect("billingCityColumn");

  return (
    <WizardSection
      header={TranslationKeys.Common.Address}
      hasErrors={billingCityProps.error}
      submitted={submitted}
      wizardProps={wizardProps}
    >
      <FormFieldLayout
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.BillingAddress)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Customer.ImportBillingAddressDescription
        )}
        direction="horizontal"
      >
        <VerticalFormField<SelectInputProps>
          Component={SelectInput}
          {...connect("billingStreetColumn")}
          label={CsvImportHelper.getColumnSelectFieldLabel(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.StreetAddress)
          )}
          items={headersObject}
          optional
        />
        <VerticalFormField<SelectInputProps>
          Component={SelectInput}
          {...connect("billingStreet2Column")}
          label={CsvImportHelper.getColumnSelectFieldLabel(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.StreetAddress2)
          )}
          items={headersObject}
          optional
        />
        <VerticalFormField<SelectInputProps>
          Component={SelectInput}
          {...connect("billingZipCodeColumn")}
          label={CsvImportHelper.getColumnSelectFieldLabel(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PostalCode)
          )}
          items={headersObject}
          optional
        />
        <VerticalFormField<SelectInputProps>
          Component={SelectInput}
          {...billingCityProps}
          label={CsvImportHelper.getColumnSelectFieldLabel(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.City)
          )}
          items={headersObject}
          optional
        />
        <VerticalFormField<SelectInputProps>
          Component={SelectInput}
          {...connect("billingCountryCodeColumn")}
          label={CsvImportHelper.getColumnSelectFieldLabel(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Country)
          )}
          items={headersObject}
          optional
        />
      </FormFieldLayout>

      <FormFieldLayout
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.DeliveryAddress)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Customer.ImportDeliveryAddressDescription
        )}
        direction="horizontal"
      >
        <VerticalFormField<SelectInputProps>
          Component={SelectInput}
          {...connect("deliveryStreetColumn")}
          label={CsvImportHelper.getColumnSelectFieldLabel(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.StreetAddress)
          )}
          items={headersObject}
          optional
        />
        <VerticalFormField<SelectInputProps>
          Component={SelectInput}
          {...connect("deliveryStreet2Column")}
          label={CsvImportHelper.getColumnSelectFieldLabel(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.StreetAddress2)
          )}
          items={headersObject}
          optional
        />
        <VerticalFormField<SelectInputProps>
          Component={SelectInput}
          {...connect("deliveryZipCodeColumn")}
          label={CsvImportHelper.getColumnSelectFieldLabel(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PostalCode)
          )}
          items={headersObject}
          optional
        />
        <VerticalFormField<SelectInputProps>
          Component={SelectInput}
          {...connect("deliveryCityColumn")}
          label={CsvImportHelper.getColumnSelectFieldLabel(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.City)
          )}
          items={headersObject}
          optional
        />
        <VerticalFormField<SelectInputProps>
          Component={SelectInput}
          {...connect("deliveryCountryCodeColumn")}
          label={CsvImportHelper.getColumnSelectFieldLabel(
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Country)
          )}
          items={headersObject}
          optional
        />
      </FormFieldLayout>
    </WizardSection>
  );
};

export default AddressStep;
